"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// calculates the total price for the cruise
function totalPrice(state, getters) {
    var total = 0;
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        total += getters[cabin + '/totalPrice'];
    }
    // return sum
    return total;
}
exports.default = totalPrice;
//# sourceMappingURL=totalPrice.js.map